import { useEffect, useState } from 'react';
import { ActivityIndicator, Image, View } from 'react-native';
import { colors, styles } from '../theme';

type ProfileQrCodeProps = {
  value: string;
  compact?: boolean;
};

export function ProfileQrCode({ value, compact = false }: ProfileQrCodeProps) {
  const wrapStyle = compact ? styles.qrWrapCompact : styles.qrWrap;
  const size = compact ? 92 : 168;
  const [dataUrl, setDataUrl] = useState<string>();

  useEffect(() => {
    let cancelled = false;
    if (!value.trim()) {
      setDataUrl(undefined);
      return undefined;
    }

    void import('qrcode').then(QRCode => QRCode.toDataURL(value, {
      width: size,
      margin: 1,
      color: {
        dark: colors.text,
        light: colors.card,
      },
    })).then(url => {
      if (!cancelled) {
        setDataUrl(url);
      }
    }).catch(() => {
      if (!cancelled) {
        setDataUrl(undefined);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [size, value]);

  if (!value.trim()) {
    return (
      <View style={wrapStyle}>
        <ActivityIndicator color={colors.interactiveStrong} />
      </View>
    );
  }

  if (!dataUrl) {
    return (
      <View style={wrapStyle}>
        <ActivityIndicator color={colors.interactiveStrong} />
      </View>
    );
  }

  return (
    <View style={wrapStyle}>
      <Image source={{ uri: dataUrl }} style={{ width: size, height: size }} />
    </View>
  );
}
